import { SdmMatchConfig } from "../models/site";
import axiosConfig from "./axiosConfig";

const postSiteMarketplaceMatch = async (
  authToken: string,
  siteId: string,
  match: SdmMatchConfig
): Promise<void> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/marketplace`,
    match,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postSiteMarketplaceMatch;
